import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

const AddCallListOption = ({ data, innerProps, innerRef, label }) => (
  <div ref={innerRef} {...innerProps} className="entity" name="add-call-list" onClick={data.onClick}>
    <FontAwesomeIcon className="type-icon" icon={faPlus} pull="left" size="lg" />
    <strong>{label}</strong>
  </div>
);

AddCallListOption.propTypes = {
  data: PropTypes.shape({
    onClick: PropTypes.func.isRequired
  }).isRequired,
  innerProps: PropTypes.object,
  innerRef: PropTypes.object,
  label: PropTypes.string.isRequired
};

export default AddCallListOption;
